import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../core/api/api.service';
import { ApiResult } from '../../core/models/api/api-result.model';
import { PackageModel } from '../models/packets/packet.model';





@Injectable({
  providedIn: 'root'
})
export class HomeService {




  constructor(private readonly apiService: ApiService)
  {

  }


  public getPackets(): Observable<ApiResult<PackageModel[]>> {

    return this.apiService.get<PackageModel[]>('/packets');

  }
}
